// Convenience function untuk backward compatibility dengan Fancybox
import { useModal } from './ModalProvider';

let modalAPI = null;

export const setModalAPI = (api) => {
  modalAPI = api;
};

const modal = (content, options) => {
  if (!modalAPI) {
    console.warn('Modal API not initialized. Make sure ModalProvider is mounted.');
    return null;
  }

  const id = modalAPI.openModal(content, options);

  // Return object dengan method close() untuk compatibility dengan Fancybox
  return {
    id,
    close: () => modalAPI.closeModal(id),
    // Tambahkan method lain yang mungkin digunakan oleh Fancybox
    getSlide: () => ({ $content: { firstChild: null } }),
    clearContent: () => { },
    setContent: () => { }
  };
};

// Add static close methods for backward compatibility
modal.close = () => {
  if (modalAPI) {
    modalAPI.closeLastModal();
  }
};

modal.closeAll = () => {
  if (modalAPI) {
    modalAPI.closeAll();
  }
};

export default modal;
